export default (key) => ({
  isEnabled: {
    equality: {
      attribute: 'trustedList',
      message: '^Trusted Range cannot be empty',
      comparator: function(v1, v2) {
        if (v2?.length === 0) {
          return false;
        }
        return true;
      }
    }
  },
  [key]: {
    array: {
      from: {
        regexChecker: {
          regex: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
          mandatory: true,
          field: 'IP Address'
        }
      },
      to: {
        regexChecker: {
          regex: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
          mandatory: true,
          field: 'IP Address'
        }
      }
    }
  }
});
